import styled from "styled-components";

const SkeletonPulse = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: permissionSkeletonPulse 1.5s ease-in-out infinite;
  border-radius: 4px;

  @keyframes permissionSkeletonPulse {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const PermissionListSkeletonLoader = ({ rows = 8 }) => {
  return (
    <div className="permissions-skeleton" aria-hidden="true">
      <SkeletonPulse
        style={{
          height: "38px",
          width: "100%",
          maxWidth: "480px",
          marginBottom: "12px",
          borderRadius: "5px",
        }}
      />
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="d-flex justify-content-between align-items-center px-3 py-2 mb-2"
          style={{ backgroundColor: "#fafafa" }}
        >
          <div className="d-flex align-items-center gap-2 flex-grow-1">
            <SkeletonPulse style={{ width: "16px", height: "16px", flexShrink: 0 }} />
            <SkeletonPulse
              style={{
                height: "14px",
                width: index % 3 === 0 ? "55%" : index % 3 === 1 ? "40%" : "65%",
                maxWidth: "220px",
              }}
            />
          </div>
          <SkeletonPulse style={{ width: "24px", height: "24px", flexShrink: 0 }} />
        </div>
      ))}
    </div>
  );
};

export default PermissionListSkeletonLoader;
